import { Huddle, HuddleStatus } from 'lib/generated/graphql';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { Button } from 'src/shared-components';

const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';

const HuddleStatusComponent = ({
  huddle,
  suggestion = false,
  optIn,
}: {
  huddle: Huddle;
  suggestion?: boolean;
  optIn?: () => void;
}) => (
  <>
    {huddle?.status === HuddleStatus.LiveProject && (
      <div className="flex">
        <div className="flex mr-3">
          {huddle?.builders?.map((builder, index) => (
            <Link key={builder?.user?.username} href={`/${builder?.user?.username}`}>
              <a>
                <div
                  className={`h-8 w-8 relative rounded-xl -ml-1 outline outline-2 outline-white hover:opacity-80 cursor-pointer`}
                  style={{ zIndex: huddle?.builders.length - index }}
                >
                  <Image className="rounded-xl" layout="fill" src={builder?.user?.photoUrl || DEFAULT_USER_AVATAR} />
                </div>
              </a>
            </Link>
          ))}
        </div>
        <div className="text-sm text-[#595959] font-medium ">
          <div className="bg-[#F2F2F2] py-1.5 px-6 rounded-3xl">Team Active</div>
        </div>
      </div>
    )}
    {huddle?.status === HuddleStatus.Expired && (
      <div className="text-sm text-[#595959] font-medium ">
        <div className="bg-[#F2F2F2] py-1.5 px-6 rounded-3xl">Expired</div>
      </div>
    )}
    {huddle?.status === HuddleStatus.PastProject && (
      <div className="text-sm text-[#595959] font-medium ">
        <div className="bg-[#F2F2F2] py-1.5 px-6 rounded-3xl">Past Project</div>
      </div>
    )}
    {suggestion && (
      <Button
        size="lg"
        data-testid="optInButton"
        className={`w-full ml-4 sm:w-fit mt-4 sm:mt-0 ${huddle?.hasUserOptedin && 'cursor-auto hover:bg-gray-200'}`}
        fullWidth
        color={huddle?.hasUserOptedin ? 'gray' : 'black'}
        onClick={optIn}
        disabled={huddle?.status !== HuddleStatus.TeamForming}
      >
        {huddle?.hasUserOptedin ? "✋ I'm interested ✔️" : "✋ I'm interested"}
      </Button>
    )}
  </>
);

export default HuddleStatusComponent;
